// extracted by mini-css-extract-plugin
module.exports = {"searchbar":"SearchInput_searchbar__BmHlL","criteriaList":"SearchInput_criteriaList__1GiGn"};